// import AsyncStorage from '@react-native-community/async-storage';
import _ from 'lodash';

import auth from '../../apis/auth';
import * as types from '../constants/ActionTypes';
import {setItem, getItem} from '../../utils/handleStorage';

// ex) state를 받아둔다음, 초기화 dispatch를 날려 state를 비운다.의 로직인것같음
// const {cart} = getState();
// dispatch({
//   type: types.CHECKOUT_REQUEST
// });

const receiveUserAuth = userAuth => ({
  type: types.RECEIVE_EXERCISE,
  userAuth,
});

// dispatch(action)으로 액션을 급파보낸다 > reducer 작동
export const login = (email, password) => async (dispatch, getState) => {
  try {
    const result = await auth.login(email, password);
    if(result?.data?.result) {
      await setItem('session', result.data.data.accessToken, 30);
      // console.log(getItem('session'));
      return result;
      // return {accessToken: await getItem('session')};
    } else {
      console.log('result of login', result.data, 'se');
      return result;
    }

    // await setItem('session', result.data.data.accessToken, 30);
    // console.log('setItem result', result);

    // return {accessToken: await getItem('session')};
  } catch (e) {
    console.log('login err', e);
    throw e;
  }
};

export const getUserAccessToken = async (dispatch, getState) => {
  const userAuth = getState().user.userAuth;

  if (!_.isNil(userAuth.accessToken)) {
    return userAuth.accessToken;
  }

  try {
    const accessToken = await getItem('session');

    // if (_.isNil(accessToken)) {
    // 로그인 창으로
    // }

    return accessToken;
  } catch (e) {
    // 데이터 검색 오류
    console.log(e);
  }
};

// dispatch(action)으로 액션을 급파보낸다 > reducer 작동
export const requestAuthCode = phoneNumber => async dispatch => {
  try {
    const result = await auth.requestAuthCode(phoneNumber);

    return result.data;
  } catch (e) {
    console.log(e);
  }
};
